import React from 'react'
import {ReactComponent as UploadIcon} from "../../../resources/images/upload-icon.svg";
import { useTheme } from "react-jss";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import { AIRLINES } from '../../../constants/appConstants';

const CustomInput = (props) => {
  const {
    className,
    labelClassName,
    labelWithFilesClassName,
    style,
    labelStyle,
    labelWithFilesStyle,
    getFilesFromEvent,
    accept,
    multiple,
    disabled,
    content,
    withFilesContent,
    onFiles,
    files,
    providerCode,
  } = props

  const theme = useTheme();
  const classes = styles({ theme });

  const getText = () => {
    switch (providerCode) {
      case AIRLINES.CHOICE:
        return (
          <p>
            <a><FormattedMessage id="ucdropzone.uploadLinkTextCHOICE"/></a>&nbsp;
            <FormattedMessage id="ucdropzone.uploadText"/>
          </p>
        )
      default:
        return (
          <p>
            <a><FormattedMessage id="ucdropzone.uploadLinkText"/></a>&nbsp;
            <FormattedMessage id="ucdropzone.uploadText"/>
          </p>
        )
    }
  }

  return (
    <label
      className={classes.input}
      style={files.length > 0 ? labelWithFilesStyle : labelStyle}
    >
      <div className={classes.uploadIcon}>
        <UploadIcon className={classes.iconColor} />
      </div>
      { getText() }
      <p className={classes.csvText}><FormattedMessage id="ucdropzone.csv"/></p>
      <input
        className={className}
        style={style}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={async e => {
          const target = e.target
          const chosenFiles = await getFilesFromEvent(e)
          onFiles(chosenFiles)
          target.value = null
        }}
      />
    </label>
  )
}

export default CustomInput
